module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-deposit"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("D" + _vm._s(_vm.item.id))]), _c('small', {
    style: (_vm.item.status === 'FAIL' ? 'color:red' : '')
  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Date")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.reason))])])]), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Amount")]), _c('h3', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount)))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Walletable")]), (_vm.walletable) ? _c('h3', [_c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.walletable_id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.walletable) + _vm._s(_vm.item.walletable_id))])], 1) : _vm._e()]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Invoice")]), (_vm.item.invoice_id) ? _c('h3', [_c('router-link', {
    attrs: {
      "to": {
        name: 'invoice',
        params: {
          id: _vm.item.invoice_id
        }
      }
    }
  }, [_vm._v("INV" + _vm._s(_vm.item.invoice_id))])], 1) : _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n6"
    },
    slot: "n6"
  }, [_vm._v("not invoiced")])])])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-539fa212!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Deposit.vue
// module id = 2350
// module chunks = 1